export const SVG_ICONS = {
    INPUt_ICON: `<svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
    <g filter="url(#filter0_dii_2410_1096)">
      <circle cx="28" cy="27" r="25" fill="#F7EDFF"/>
      <circle cx="28" cy="27" r="23.5" stroke="url(#paint0_linear_2410_1096)" stroke-width="3"/>
    </g>
    <g filter="url(#filter1_d_2410_1096)">
      <mask id="mask0_2410_1096" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="15" y="12" width="31" height="30">
        <rect x="15.9626" y="12.1851" width="29.6296" height="29.6296" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_2410_1096)">
        <path d="M19.6665 36.8764V17.1233L43.1233 26.9998L19.6665 36.8764ZM22.1356 33.1727L36.7653 26.9998L22.1356 20.827V25.148L29.543 26.9998L22.1356 28.8517V33.1727Z" fill="#662C90"/>
      </g>
    </g>
    <defs>
      <filter id="filter0_dii_2410_1096" x="-1" y="-2" width="59" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="1" dy="2"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2410_1096"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2410_1096" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="4" dy="2"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.172549 0 0 0 0 0.564706 0 0 0 0.78 0"/>
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2410_1096"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="-6" dy="-5"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/>
        <feBlend mode="normal" in2="effect2_innerShadow_2410_1096" result="effect3_innerShadow_2410_1096"/>
      </filter>
      <filter id="filter1_d_2410_1096" x="19.6665" y="17.1233" width="25.4568" height="21.7532" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="1" dy="1"/>
        <feGaussianBlur stdDeviation="0.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.700833 0 0 0 0 0.700833 0 0 0 0 0.700833 0 0 0 0.31 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2410_1096"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2410_1096" result="shape"/>
      </filter>
      <linearGradient id="paint0_linear_2410_1096" x1="40.5" y1="2" x2="18" y2="46.375" gradientUnits="userSpaceOnUse">
        <stop stop-color="#9D53D3"/>
        <stop offset="1" stop-color="#DBB8F4"/>
      </linearGradient>
    </defs>
  </svg>`,
    DONNA_ICON: `<svg xmlns="http://www.w3.org/2000/svg" width="43" height="45" viewBox="0 0 43 45" fill="none">
  <path d="M21.3881 6V12.6706L15.6704 18.3882" stroke="#662C90" stroke-width="2"/>
  <circle cx="14.0822" cy="19.6589" r="1.85883" stroke="#662C90" stroke-width="2"/>
  <path d="M9.00159 29.8236L19.484 21.8364L29.025 21.8364" stroke="#662C90" stroke-width="2"/>
  <circle cx="31.0501" cy="22.026" r="1.85883" transform="rotate(-136.013 31.0501 22.026)" stroke="#662C90" stroke-width="2"/>
  <path d="M35.6823 13.3059H29.9647L26.4706 15.8471" stroke="#662C90" stroke-width="2"/>
  <circle cx="24.8824" cy="17.1176" r="1.85883" stroke="#662C90" stroke-width="2"/>
  <path d="M35.9997 28.8701H27.589H22.6585" stroke="#662C90" stroke-width="2"/>
  <path d="M20.1176 37.1293V33.1242V30.7764" stroke="#662C90" stroke-width="2"/>
  <circle cx="20.4353" cy="28.8705" r="1.85883" stroke="#662C90" stroke-width="2"/>
  <g filter="url(#filter0_dd_2474_863)">
    <circle cx="22" cy="22" r="16" stroke="url(#paint0_linear_2474_863)" stroke-width="2" shape-rendering="crispEdges"/>
  </g>
  <defs>
    <filter id="filter0_dd_2474_863" x="0" y="0" width="43" height="45" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-1" dy="-1"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2474_863"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="2"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_dropShadow_2474_863" result="effect2_dropShadow_2474_863"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2474_863" result="shape"/>
    </filter>
    <linearGradient id="paint0_linear_2474_863" x1="30.5" y1="5" x2="15.2" y2="35.175" gradientUnits="userSpaceOnUse">
      <stop stop-color="#9D53D3"/>
      <stop offset="1" stop-color="#DBB8F4"/>
    </linearGradient>
  </defs>
  </svg>`
}